import StoreService from '../ephemeral-store'
import UtilService from '../util'

export const WORKSPACE_KEY = 'workspace'

export default class SessionService {
    static getWorkspace() {
        const store = new StoreService()

        return store.get(WORKSPACE_KEY)
            .then((workspaceJson) => {
                if (workspaceJson) {
                    try {
                        return JSON.parse(workspaceJson)
                    }
                    catch(e) {
                        UtilService.safeLog('Failed to parse saved workspace')
                    }
                }

                return null
            })
    }

    static setWorkspace(workspace) {
        const store = new StoreService()

        try {
            const workspaceJson = JSON.stringify(workspace)
            return store.set(WORKSPACE_KEY, workspaceJson)
        }
        catch(e) {
            UtilService.safeLog('Failed to encode workspace for storage')
        }

        return null
    }

    static clearWorkspace() {
        const store = new StoreService()

        return store.remove(WORKSPACE_KEY)
    }
}


// WEBPACK FOOTER //
// src/services/session/index.js